module.exports = __webpack_public_path__ + "static/media/GTD-WEB.bd38bbcd.png";